import qs from 'qs'

export default {
  'SET_TRADER_WINDOW' (state, { id, window, hasMarkets }) {
    state.windows[id] = {
      id,
      window,
      hasMarkets
    }
  },
  'DELETE_TRADER_WINDOW' (state, id) {
    state.windows[id] = null
  },
  'SET_TRADER_POPUP_PLAYER' (state, { id, streamName, sign }) {
    Vue.set(state.playerWindows, id, {
      id,
      streamName,
      sign
    })
  },
  'DELETE_TRADER_POPUP_PLAYER' (state, id) {
    state.playerWindows[id] = null
  },
  'SET_EXTRA_TITLE' (state, value) {
    state.header.extraTitle = value
  },
  'SET_SUB_TITLE' (state, value) {
    state.header.subTitle = value
  },
  'SET_COUNTER' (state, value) {
    state.header.counter = value
  },
  'SET_HEADER_TRADER_MODE' (state, value) {
    state.header.traderMode = value
  },
  'SET_DOWNLOAD_LINK' (state, value) {
    if (typeof value === 'string') {
      state.header.downloadLink = value

      return
    }
    const { path, params } = value
    const slash = process.env.VUE_APP_API_PATH[process.env.VUE_APP_API_PATH.length - 1] === '/' ? '' : '/'

    delete params.length
    params.start = 0

    state.header.downloadLink = `${process.env.VUE_APP_API_PATH}${slash}${path}?${qs.stringify(params, { arrayFormat: 'indices' })}`
  },
  'DISABLE_NON_SEARCH_FILTERS' (state, value) {
    state.filters.isFiltersDisabled = value
  },
  'OPEN_POP_ASIDE' (state, { title, component, data }) {
    state.popAside.title = title
    state.popAside.component = component
    state.popAside.data = data
  },
  'CLOSE_POP_ASIDE' (state) {
    state.popAside.title = ''
    state.popAside.component = ''
    state.popAside.data = ''
  },
  'SET_ASIDE_TRANSFORM' (state, value) {
    state.popAside.transform = value
  },
  'SET_SPORT_EVENTS' (state, value) {
    state.events.sportEvents = value
  },
  'SET_DEFAULT_EVENTS' (state, value) {
    state.events.defaultEvents = value
  },
  'SET_IS_MOBILE' (state, value) {
    state.isMobile = value
  },
  'ADD_NOTIFICATION_TO_QUEUE' (state, notification) {
    state.notificationsQueue.push(notification)
  },
  'REMOVE_NOTIFICATION_FROM_QUEUE' (state, notificationId) {
    const index = state.notificationsQueue.findIndex((notification) => notification.id === notificationId)

    state.notificationsQueue.splice(index, 1)
  }
}
